module.exports = __webpack_public_path__ + "img/logo-pagseguro.6ca0839a.png";